import { API } from '@/api';
import { createAsyncThunk } from '@reduxjs/toolkit';

export const createTaaw = createAsyncThunk(
  'taaw/createTaaw',
  async ({
    objective,
    region,
    spo,
    audience,
    isSecond,
  }: {
    objective: string;
    region: string;
    spo: string;
    audience: string;
    isSecond: boolean;
  }) => API.taaws.createTaaw({ objective, region, spo, audience, isSecond }),
);

export const retrieveTaaw = createAsyncThunk(
  'taaw/getTaaw',
  async ({ jobId, prevData }: { jobId: string; prevData: any }) =>
    API.taaws.getTaaw({ jobId, prevData }),
);

export const createKbs = createAsyncThunk(
  'kb/create',
  async ({
    obj,
    region,
    spo,
    ta,
    specificStudioId,
  }: {
    obj: string;
    region: string;
    spo: string;
    ta: string;
    specificStudioId?: string;
  }) => API.kbs.createKbs({ obj, region, spo, ta, specificStudioId }),
);

export const getKb = createAsyncThunk(
  'kb/get',
  async ({
    jobId,
    project,
    studioId,
    sec_id,
  }: {
    jobId: string;
    project: string;
    studioId: string;
    sec_id: string;
  }) => API.kbs.getKb({ jobId, project, studioId, sec_id }),
);

export const getAllRtagOptions = createAsyncThunk(
  'taaw/getRtagsOptions',
  async ({ ptalRefId }: { ptalRefId: string }) =>
    API.reports.getRtagsOptions({ ptalRefId }),
);
